import { getSentry } from "@solvari/utils";

function lazyLoadIntersection() {
  if (!getIntersectionAssetContainers(null).length) {
    return;
  }

  try {
    initObservers();
  } catch (error) {
    getSentry().captureException(error);
    getIntersectionAssets(null).forEach(loadAsset);
  }
}

function initObservers() {
  const smallObserver = new IntersectionObserver(
    loadIntersectionContainerAssets,
    { rootMargin: "50px" },
  );
  startObserver(smallObserver);

  document.addEventListener(
    "scroll",
    () => {
      smallObserver.disconnect();

      const bigObserver = new IntersectionObserver(
        loadIntersectionContainerAssets,
        { rootMargin: "400px" },
      );
      startObserver(bigObserver);
    },
    { passive: true, once: true },
  );
}

function startObserver(observer: IntersectionObserver) {
  getIntersectionAssetContainers(null).forEach((container) =>
    observer.observe(container),
  );
}

function loadIntersectionContainerAssets(
  entries: IntersectionObserverEntry[],
  observer: IntersectionObserver,
) {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      return;
    }

    const assetId =
      (entry.target as HTMLElement).dataset.lazyAssetContainer ?? null;
    getIntersectionAssets(assetId).forEach(loadAsset);
    getIntersectionAssetContainers(assetId).forEach((container) =>
      observer.unobserve(container),
    );
  });
}

function getIntersectionAssetContainers(assetId: string | null) {
  return document.querySelectorAll<HTMLElement>(
    assetId
      ? `[data-lazy-asset-container=${assetId}]`
      : "[data-lazy-asset-container]",
  );
}

function getIntersectionAssets(assetId: string | null) {
  return document.querySelectorAll<HTMLScriptElement | HTMLStyleElement>(
    assetId ? `[data-lazy-asset-id=${assetId}]` : "[data-lazy-asset-id]",
  );
}

function loadAsset(element: HTMLScriptElement | HTMLStyleElement) {
  if (element.dataset.href) {
    element.setAttribute("href", element.dataset.href);
    delete element.dataset.href;
  }
  if (element.dataset.src) {
    element.setAttribute("src", element.dataset.src);
    delete element.dataset.src;
  }
  delete element.dataset.lazyAssetId;
}

export { lazyLoadIntersection };
